import { IMoveDataReportEntry, UserHistory, UserModel } from 'app/models/core/user.model';
import { formatDateLong } from 'app/utils';
import { observer } from 'mobx-react';
import routes from 'routes';

interface IUserHistoryList {
	user: UserModel;
}

const formatChangeValue = (v: any) => {
	if (v === null || v === undefined || v === '') {
		return <em>—</em>;
	}
	if (typeof v === 'object') {
		return JSON.stringify(v);
	}
	return String(v);
};

export const AdminUserHistoryList = observer((props: IUserHistoryList) => {
	const parseMoveDataReport = (data?: string): IMoveDataReportEntry[] | null => {
		if (!data) {
			return null;
		}
		try {
			const parsed = JSON.parse(data);
			if (Array.isArray(parsed)) {
				return parsed as IMoveDataReportEntry[];
			}
		} catch {
			return null;
		}
		return null;
	};

	const getAction = (h: UserHistory) => {
		switch (h.action) {
			case 'transferFrom':
				if (h.data) {
					const transferLink = '#' + routes.ADMINBNRTRANSFER.getPath(h.data);
					return <a href={transferLink}>{h.data}</a>;
				}
				return <></>;

			case 'bnrIdUpdate':
				return <>Vorherige BnrId {h.data}</>;
			case 'moveData': {
				const report = parseMoveDataReport(h.data);
				if (report) {
					return renderMoveDataReport(report);
				}
				return <>{h.data}</>;
			}
			default:
				break;
		}
		return <></>;
	};

	const renderMoveDataReport = (report: IMoveDataReportEntry[]) => {
		if (report.length === 0) {
			return null;
		}
		return (
			<ul className="user-history-what">
				{report.map((row) => (
					<li key={row.entity}>
						<strong>{row.entity}:</strong> {row.rowsUpdated} Zeilen
					</li>
				))}
			</ul>
		);
	};

	const renderWhat = (h: UserHistory) => {
		if (!h.what) {
			return null;
		}
		if (Array.isArray(h.what)) {
			return renderMoveDataReport(h.what);
		}
		const fieldChanges = h.what;
		const fields = Object.keys(fieldChanges);
		if (fields.length === 0) {
			return null;
		}
		return (
			<ul className="user-history-what">
				{fields.map((field) => {
					const change = fieldChanges[field];
					return (
						<li key={field}>
							<strong>{field}:</strong> {formatChangeValue(change.from)} →{' '}
							{formatChangeValue(change.to)}
						</li>
					);
				})}
			</ul>
		);
	};

	const renderWhy = (h: UserHistory) => {
		if (!h.why) {
			return null;
		}
		return (
			<div className="user-history-why">
				<em>Grund:</em> {h.why}
			</div>
		);
	};

	return (
		<ul>
			{props.user.history.map((h) => (
				<li key={h.date!.getTime()}>
					{formatDateLong(h.date)} {h.action} {getAction(h)}
					{renderWhat(h)}
					{renderWhy(h)}
				</li>
			))}
		</ul>
	);
});
